module.exports = __webpack_public_path__ + "img/16_116.1d885668.png";